export default __webpack_public_path__ + "static/media/civil3d2706to01072022.93dab4a7.jpeg";